import { findInArr } from '@crunchyroll/cr-static-shared-components'
import { isGeolock } from 'utils/is-geolock'

export const filterByGeolock = (games = [], countryCode = '') => {
  return games?.filter((game) => {
    const geolock = game?.content?.geolock
    const isBlocked = isGeolock({ geolock, countryCode })
    if (!isBlocked) return game
    return false
  })
}

export const filterByCategory = (
  cards = [],
  selectedCategories = [],
  globalLabels,
  isClicked
) => {
  return cards?.filter((card) => {
    if (!selectedCategories?.length) return card
    const type = card?.content?.type
    if (!type) return null

    if (!isClicked || !selectedCategories?.length) {
      return card
    }
    const selectedCategorySet = new Set(selectedCategories)
    const matchBadgeLabel =
      globalLabels && findInArr(globalLabels, 'id', type)?.title
    return selectedCategorySet.has(matchBadgeLabel)
  })
}

export const filterByGenre = (
  cards,
  selectedGenres,
  globalGenreLabels,
  isClicked
) => {
  return cards?.filter((card) => {
    const genre = card?.content?.genre
    if (!genre) return null

    const genreLocalized = genre?.map((item) => {
      return findInArr(globalGenreLabels, 'id', item)?.title
    })

    const genreSet = new Set(genreLocalized)

    if (!isClicked || !selectedGenres?.length) {
      return card
    }

    const matches = selectedGenres?.map((genre) => genreSet.has(genre))

    return matches.every((val) => val)
  })
}

export const filterByPlatform = (cards, selectedPlatforms, isClicked) => {
  return cards?.filter((card) => {
    const platformLinks = card?.content?.platformLinks || []
    const legacyPlatforms = card?.content?.platforms || []

    const platformExtract = platformLinks?.map(({ platform }) =>
      platform?.toLowerCase()
    )

    const platformExtractCleaned = platformExtract?.filter(
      (platform) => platform?.length
    )

    const allPlatforms = [...legacyPlatforms, ...platformExtractCleaned]

    const platformSet = new Set(allPlatforms)
    const formattedPlatforms = selectedPlatforms?.map((platform) =>
      platform.toLowerCase()
    )

    if (!isClicked || !formattedPlatforms?.length) {
      return card
    }

    if (!allPlatforms?.length) return false

    const matches = formattedPlatforms?.map((platform) => {
      return platformSet.has(platform)
    })

    return matches.every((val) => val)
  })
}

export const getUrlFilter = (param) => {
  if (typeof window !== 'undefined') {
    return (
      window && window.location.search && window.location.search.includes(param)
    )
  }
}

export const getUniqueFilterList = (
  array = [],
  contentKey = '',
  secondaryKey = '',
  localizedMap
) => {
  let set = new Set()

  array?.forEach((card) => {
    const list = card?.content[contentKey]

    if (list)
      list?.forEach((item) => {
        let selectedItem

        if (!!secondaryKey?.length) {
        } else if (localizedMap) {
          const matchLocaleItem = findInArr(localizedMap, 'id', item)?.title
          selectedItem = matchLocaleItem
        } else {
          selectedItem = item
        }

        if (selectedItem && !set.has(selectedItem)) set.add(selectedItem)
      })
  })

  return Array.from(set)
}

export const filterByType = (
  array = [],
  contentKey = '',
  matchList,
  secondaryKey = '',
  customCondition,
  useCustomCondition = false
) => {
  const isCustom = useCustomCondition && customCondition
  const filtered = array?.filter((item) => {
    const content = item?.content
    const primaryValue = content[contentKey]
    const checkSecondaryKey = primaryValue && secondaryKey
    if (checkSecondaryKey) {
      const secondarySearch = primaryValue?.find((item) => {
        const secondaryValue = item[secondaryKey]?.toLowerCase()
        const targetCondition = isCustom
          ? customCondition
          : matchList.includes(secondaryValue)
        return targetCondition
      })

      return secondarySearch
    } else if (primaryValue) {
      const targetCondition = isCustom
        ? customCondition
        : primaryValue?.find((item) => matchList.includes(item))

      return targetCondition
    } else return null
  })

  return filtered
}
